import {
  expireWards,
  applyTrueSightFromWards
} from '../../domain/vision.js';

/** Vision update interval — Season 2 FoW ticks at 10 Hz. */
export const VISION_TICK_INTERVAL = 0.1;

/**
 * updateVision — Application tick for wards + true sight (P3-10).
 * Mutates `state.activeWards` and `state.visionAcc`.
 *
 * Contrato: updateVision(state, { dt, gameTime, viewerTeam, units })
 */
export function updateVision(state, {
  dt = 0,
  gameTime = 0,
  viewerTeam = 'blue',
  units = []
} = {}) {
  if (!state) return;

  state.visionAcc = (state.visionAcc || 0) + dt;
  if (state.visionAcc < VISION_TICK_INTERVAL) return;

  state.visionAcc -= VISION_TICK_INTERVAL;
  state.activeWards = expireWards(state.activeWards || [], gameTime);
  applyTrueSightFromWards(units, state.activeWards, viewerTeam);
}
